import React from "react";

const reasons = [
  {
    icon: "fa-microchip",
    title: "AI-Driven Creativity",
    desc: "Struggling with content ideas? KnackVibes generates engaging posts, captions, and hashtags tailored to your audience.",
  },
  {
    icon: "fa-search",
    title: "Seamless Multi-Platform Posting",
    desc: "Manage all your social media accounts from a single dashboard. AI-powered candidate selection ensures better job-role fit with skill-matching insights.",
  },
  {
    icon: "fa-users",
    title: "Advanced Analytics",
    desc: "Get real-time insights on post performance, audience engagement, and growth trends. Use AI-driven data to refine your strategy and boost your social media impact.",
  },
  {
    icon: "fa fa-clock-o",
    title: "Smart Scheduling",
    desc: "Maximize engagement with AI-powered scheduling. KnackVibes analyzes audience behavior and posts at the optimal times to ensure maximum visibility.",
  },
  {
    icon: "fa-hourglass",
    title: "Brand Consistency",
    desc: "Maintain a cohesive online presence with customizable tone and style settings.",
  },
  {
    icon: "fa fa-laptop",
    title: "User-Friendly Interface",
    desc: "Designed for ease of use, KnackVibes offers an intuitive interface that makes social media management simple, even for beginners.",
  },
];

const WhyKnackVibes = () => {
  return (
    <div className="elementor-widget-container">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2>Why KnackVibes</h2>
            </div>
          </div>
        </div>

        <div className="row ">
          {reasons.map((item, idx) => (
            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" key={idx}>
              <div className="item-knackhire text-center p-4">
                <div className="icon-knackhire mb-3">
                  <i className={`fa ${item.icon} fa-2x`}></i>
                </div>
                <div className="info">
                  <h4 className="knackhire-headings">{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .site-heading {
          margin-bottom: 45px;
          text-align: center;
        }
        .site-heading h2 {
          font-weight: 600;
        }

        .item-knackhire {
          padding: 30px;
          background-color: #fff;
          border-radius: 5px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          height: 300px;
          margin-bottom: 30px;
        }

        .icon-knackhire {
          color: #2e3192;
          font-size: 40px;
        }

        .knackhire-headings {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          margin-top: 20px;
        }

        p {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
        }

        /* Media Queries */
        @media (max-width: 992px) {
          .item-knackhire {
            height: auto; /* Allow for flexible height on smaller screens */
          }
        }

        @media (max-width: 768px) {
          .site-heading h2 {
            font-size: 28px;
          }

          .item-knackhire {
            padding: 20px;
          }

          .icon-knackhire {
            font-size: 35px;
          }

          .knackhire-headings {
            font-size: 18px;
          }

          p {
            font-size: 13px;
          }
        }

        @media (max-width: 576px) {
          .site-heading h2 {
            font-size: 24px;
          }

          .item-knackhire {
            padding: 15px;
          }

          .icon-knackhire {
            font-size: 30px;
          }

          .knackhire-headings {
            font-size: 16px;
          }

          p {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default WhyKnackVibes;
